import { MdSlowMotionVideo } from "react-icons/md"

const Video = ({videos}) => {

      if(videos.data) return 
      
      const video_src = `https://www.youtube.com/embed/${videos[0].id_video}`
      return (
            <div className="box_wrapper">
                  <div className="header_box__content">
                        <div className="header_content_icon">
                              <MdSlowMotionVideo />
                        </div>
                        <h3>Video</h3>
                  </div>
                  <div className="box_content main">
                        <div className="video_wrapper">
                              <div className="video_box">
                                    <iframe width="100%" height="100%" src={video_src}title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                              </div>
                              <div className="video_description">
                                    <p>{videos[0].title}</p>
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Video